import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { Menuitem } from "../../../../../interfaces/Security/menu";
import GenericPromises from "../../../../../api/GenericPromises";
import { SnackbarComponent } from "../../../../../components/Commons/SnackBar";
import { Button } from "@mui/material";
import { Spinner } from "../../../../../components/Commons/Spinner/Spinner";
import { Header } from "../../../../../components/Header";
import { usePermissions } from "../../../../../hooks/usePermissions";
import { GenericDialog } from "../../../../../components/Dialogs/Dialog";
import { ButtonStyled } from "../../../../../theme/buttons";
import { HazardousMaterialKey } from "../../../../../interfaces/Sales/Catalogs/TransportationDocuments/hazardousMaterialsKeys";
import { UpdateHazardousMaterialsKeys } from "./update";
import useSnackBar from "../../../../../components/Commons/SnackBar/useSnackBar";

export const ViewHazardousMaterialsKeys = () => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const navigate = useNavigate();
  const [hazardousMaterialsKeysLocal, setHazardousMaterialsKeysLocal] = useState<HazardousMaterialKey>();
  const [openDialog, setOpenDialog] = useState(false);
  const [dataloaded, setDataLoaded] = useState(false);
  const { GenericGetResource, GenericDeleteResource } = GenericPromises();
  const { showSnackBar, SnackbarComponent } = useSnackBar();
  const [resourceScreen, setResourceScreen] = useState<Menuitem>();
  const { GetResourceByUrl } = usePermissions();

  const onDelete = () => {
    GenericDeleteResource(`/hazardousmaterialskeys/${hazardousMaterialsKeysLocal?.hazardous_material_key_id}`)
      .then(() => {
        setOpenDialog(false);
        navigate("/hazardousmaterialskeys", { state: { method: "delete" }, replace: true });
      })
      .catch((error) => {
        showSnackBar(error.message, 'error');
        setOpenDialog(false);
      })
  }

  useEffect(() => {
    if (location.state === null) return navigate("/hazardousmaterialskeys", { state: {}, replace: true });
    GenericGetResource(`/hazardousmaterialskeys/${location.state.row.hazardous_material_key_id}`)
      .then(
        (response) => {
          setHazardousMaterialsKeysLocal(response.data);

          GetResourceByUrl(`/hazardousmaterialskeys`)
            .then((response1) => {
              setResourceScreen((prev) => response1);
              setDataLoaded(true);
            })
            .catch((error) => {
              showSnackBar(error.message, 'error');
            });
        }
      ).catch((error) => {
        showSnackBar(error.message, 'error');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!dataloaded && <Spinner />}
      {dataloaded &&
        <>
          <Header
            title={t("hazardousmaterialskeys.title-view")}
            child={
              <div className='d-flex flex-row-reverse m-1'>
                {resourceScreen?.delete === true &&
                  <ButtonStyled variant="contained" className="my-1" onClick={() => setOpenDialog(true)}>{t("generic.buttons.delete")}</ButtonStyled>
                }
                <Button variant="outlined" onClick={() => { navigate("/hazardousmaterialskeys", { replace: true }) }}>{t("generic.buttons.goback")}</Button>
              </div>
            }
          />
          {resourceScreen?.read &&
            <>
              <div>
                <UpdateHazardousMaterialsKeys hazardousMaterialsKeyPayload={hazardousMaterialsKeysLocal} isEdit={resourceScreen?.update} />
              </div>
            </>
          }
        </>
      }
      <GenericDialog
        title={t("generic.dialog.delete")}
        content={t("hazardousmaterialskeys.dialog.delete")}
        open={openDialog}
        setOpen={setOpenDialog}
        onAcept={onDelete}
      />
      <SnackbarComponent />
    </>
  )
}
